export const truncText = (text: string, limit: number) => {
  if (!text) return "";

  return text.slice(0, limit);
};

export const inBetween = (value: number, a: number, b: number) =>
  a <= value && value <= b;
